<template>
  <form v-on:input="handleFormChanges">
    <fieldset v-if="choices.arrangements.length > 0" class="block-centered width-75 add-large-top-margin">
      <label class="type-h6 color-silver-dark add-margin" v-text="step.packages.arrangements"></label>
      <div v-for="(choice, index) in choices.arrangements" :key="choice.Id" class="form-group__wrapper--inline-flex form-group--radio flex--align-center flex--between">
        <input
          type="radio"
          class="input-radio"
          :id="`${choice.Name}-${index}`"
          :key="`${choice.Name}-${index}-input`"
          name="arrangements"
          :data-vv-as="step.packages.arrangements"
          :value="choice.Id"
          v-model="selectedMaterials.arrangements"
          v-validate="'required'"
          data-vv-validate-on="input"/>
        <label
          class="type-label"
          :key="`${choice.Name}-${index}-label`"
          :for="`${choice.Name}-${index}`">
          <span v-text="choice.Name"></span>
          <div class="tooltip">
            <span tabindex="0" class="tooltip__button tooltip__button-small" type="button" aria-label="more info" :data-toggletip-content="choice.Description">
              <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Tooltip</title>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-295.000000, -864.000000)" fill-rule="nonzero" fill="#000000">
                    <g transform="translate(295.000000, 864.000000)">
                      <path d="M7.5,14.5588235 C3.60151941,14.5588235 0.441176471,11.3984806 0.441176471,7.5 C0.441176471,3.60151941 3.60151941,0.441176471 7.5,0.441176471 C11.3984806,0.441176471 14.5588235,3.60151941 14.5588235,7.5 C14.5588235,11.3984806 11.3984806,14.5588235 7.5,14.5588235 Z M7.5,13.6764706 C10.9111705,13.6764706 13.6764706,10.9111705 13.6764706,7.5 C13.6764706,4.08882949 10.9111705,1.32352941 7.5,1.32352941 C4.08882949,1.32352941 1.32352941,4.08882949 1.32352941,7.5 C1.32352941,10.9111705 4.08882949,13.6764706 7.5,13.6764706 Z M7.01294118,11.4705882 L7.01294118,6.45176471 L8.28352941,6.45176471 L8.28352941,11.4705882 L7.01294118,11.4705882 Z M6.81176471,4.83176471 C6.81176471,4.36588235 7.18235294,3.99529412 7.64823529,3.99529412 C8.11411765,3.99529412 8.48470588,4.36588235 8.48470588,4.83176471 C8.48470588,5.29764706 8.11411765,5.66823529 7.64823529,5.66823529 C7.18235294,5.66823529 6.81176471,5.29764706 6.81176471,4.83176471 Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="tooltip__content" role="status"></span>
          </div>
        </label>
      </div>
    </fieldset>
    <fieldset v-if="choices.playsWithMusic.length > 0" class="block-centered width-75 add-large-top-margin">
      <label class="type-h6 color-silver-dark add-margin" v-text="step.packages.playsWithMusic"></label>
      <div v-for="(choice, index) in choices.playsWithMusic" :key="choice.Id" class="form-group__wrapper--inline-flex form-group--radio flex--align-center flex--between">
        <input
          type="radio"
          class="input-radio"
          :id="`${choice.Name}-${index}`"
          :key="`${choice.Name}-${index}-input`"
          name="playsWithMusic"
          :data-vv-as="step.packages.playsWithMusic"
          :value="choice.Id"
          v-model="selectedMaterials.playsWithMusic"
          :checked="requiresMusicFee && index === 0"
          :v-validate="requiresMusicFee ? 'required' : null"
          data-vv-validate-on="input"/>
        <label
          class="type-label"
          :key="`${choice.Name}-${index}-label`"
          :for="`${choice.Name}-${index}`">
          <span v-text="choice.Name"></span>
          <div class="tooltip">
            <span tabindex="0" class="tooltip__button tooltip__button-small" type="button" aria-label="more info" :data-toggletip-content="choice.Description">
              <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Tooltip</title>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-295.000000, -864.000000)" fill-rule="nonzero" fill="#000000">
                    <g transform="translate(295.000000, 864.000000)">
                      <path d="M7.5,14.5588235 C3.60151941,14.5588235 0.441176471,11.3984806 0.441176471,7.5 C0.441176471,3.60151941 3.60151941,0.441176471 7.5,0.441176471 C11.3984806,0.441176471 14.5588235,3.60151941 14.5588235,7.5 C14.5588235,11.3984806 11.3984806,14.5588235 7.5,14.5588235 Z M7.5,13.6764706 C10.9111705,13.6764706 13.6764706,10.9111705 13.6764706,7.5 C13.6764706,4.08882949 10.9111705,1.32352941 7.5,1.32352941 C4.08882949,1.32352941 1.32352941,4.08882949 1.32352941,7.5 C1.32352941,10.9111705 4.08882949,13.6764706 7.5,13.6764706 Z M7.01294118,11.4705882 L7.01294118,6.45176471 L8.28352941,6.45176471 L8.28352941,11.4705882 L7.01294118,11.4705882 Z M6.81176471,4.83176471 C6.81176471,4.36588235 7.18235294,3.99529412 7.64823529,3.99529412 C8.11411765,3.99529412 8.48470588,4.36588235 8.48470588,4.83176471 C8.48470588,5.29764706 8.11411765,5.66823529 7.64823529,5.66823529 C7.18235294,5.66823529 6.81176471,5.29764706 6.81176471,4.83176471 Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="tooltip__content" role="status"></span>
          </div>
        </label>
      </div>
      <div v-if="requiresMusicFee === false" class="form-group__wrapper--inline-flex form-group--radio flex--align-center flex--between">
        <input
          type="radio"
          class="input-radio"
          id="no-play-with-music"
          key="no-play-with-music-input"
          name="playsWithMusic"
          :data-vv-as="step.packages.playsWithMusic"
          :value="null"
          v-model="selectedMaterials.playsWithMusic"/>
        <label
          class="type-label"
          key="no-play-with-music-label"
          for="no-play-with-music">
          <span>No music required</span>
        </label>
      </div>
    </fieldset>
    <fieldset v-if="selectedMaterials.scripts !== null && choices.scripts.length > 0" class="block-centered width-75 add-large-top-margin">
      <legend class="type-h6 color-silver-dark add-margin" v-text="step.packages.scripts"></legend>
      <p v-if="!minScriptCountReached" class="type-small" v-text="remainingScriptCount"></p>
      <table class="form-table">
        <thead>
          <th>Name</th>
          <th align="center">Price</th>
          <th align="center">Quantity</th>
        </thead>
        <tbody>
          <tr v-for="choice in choices.scripts" :key="choice.Id">
            <td class="type-small">
              <div class="flex flex--start">
                <div v-text="choice.Name"></div>
                <div class="tooltip">
                  <span tabindex="0" class="tooltip__button tooltip__button-small" type="button" aria-label="more info" :data-toggletip-content="choice.Description">
                    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <title>Tooltip</title>
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-295.000000, -864.000000)" fill-rule="nonzero" fill="#000000">
                          <g transform="translate(295.000000, 864.000000)">
                            <path d="M7.5,14.5588235 C3.60151941,14.5588235 0.441176471,11.3984806 0.441176471,7.5 C0.441176471,3.60151941 3.60151941,0.441176471 7.5,0.441176471 C11.3984806,0.441176471 14.5588235,3.60151941 14.5588235,7.5 C14.5588235,11.3984806 11.3984806,14.5588235 7.5,14.5588235 Z M7.5,13.6764706 C10.9111705,13.6764706 13.6764706,10.9111705 13.6764706,7.5 C13.6764706,4.08882949 10.9111705,1.32352941 7.5,1.32352941 C4.08882949,1.32352941 1.32352941,4.08882949 1.32352941,7.5 C1.32352941,10.9111705 4.08882949,13.6764706 7.5,13.6764706 Z M7.01294118,11.4705882 L7.01294118,6.45176471 L8.28352941,6.45176471 L8.28352941,11.4705882 L7.01294118,11.4705882 Z M6.81176471,4.83176471 C6.81176471,4.36588235 7.18235294,3.99529412 7.64823529,3.99529412 C8.11411765,3.99529412 8.48470588,4.36588235 8.48470588,4.83176471 C8.48470588,5.29764706 8.11411765,5.66823529 7.64823529,5.66823529 C7.18235294,5.66823529 6.81176471,5.29764706 6.81176471,4.83176471 Z"></path>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span class="tooltip__content" role="status"></span>
                </div>
              </div>
            </td>
            <td align="center" class="type-small" v-text="choice.ProductVariantPrice.Price"></td>
            <td>
              <div class="form-number-group flex flex--center color-gray">
                <button
                  type="button"
                  @click="decreaseQuantity('scripts', choice.Name)"
                  class="input-number-button" data-input="subtract"
                  data-id="quantity">-</button>
                <input
                  type="number"
                  min="0"
                  class="input-number"
                  :name="choice.Name"
                  v-model.number="selectedMaterials.scripts[choice.Name].quantity"
                />
                <button
                  type="button"
                  @click="increaseQuantity('scripts', choice.Name)"
                  class="input-number-button" data-input="add"
                  data-id="quantity">+</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
    <p>&nbsp;<span v-if="errors.any()" class="type-small error-message display-inline-block" v-text="errors.items[0].msg"></span></p>
  </form>
</template>

<script>
const { debounce, filter }  = require('lodash');

export default {
  name: 'LicenceEstimatorMaterials',
  props: {
    step: {
      required: true,
      type: Object,
    },
    productInfo: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      /** @type {Record<'scripts' | 'arrangements' | 'playsWithMusic', object[]>} */
      choices: Object.keys({ ...this.step.packages }).reduce((results, name) => {
        results[name] = filter(this.productInfo.ProductVariantModels, this.step.productVariantModelsFilter[name]);
        return results;
      }, {}),
      /** @type {Record<'scripts' | 'arrangements' | 'playsWithMusic', object[]>} */
      selectedMaterials: { ...this.step.selectedMaterials },
    };
  },
  mounted() {
    this.step.selectedMaterials.scripts = this.step.selectedMaterials.scripts === null ? {} : this.step.selectedMaterials.scripts;
    this.selectedMaterials.scripts = this.choices.scripts.reduce((results, choice) => {
      results[choice.Name] = this.step.selectedMaterials.scripts[choice.Name] || { id: choice.Id, quantity: 0 };

      return results;
    }, {});

    this.selectedMaterials.playsWithMusic = this.requiresMusicFee ? this.choices.playsWithMusic[0].Id : null;

    this.step.selectedMaterials = this.selectedMaterials;

    const hasScripts = Object.values(this.step.selectedMaterials.scripts).map(({ quantity }) => quantity).reduce((results, qty) => results + qty, 0) > 0;

    if (hasScripts || this.step.selectedMaterials.arrangements !== null || this.selectedMaterials.playsWithMusic !== null) {
      this.handleFormChanges();
    }

    this.$nextTick(() => window.reinitTooltips());
  },
  methods: {
    decreaseQuantity(name, target) {
      if (this.selectedMaterials[name][target].quantity > 0) {
        this.selectedMaterials[name][target].quantity--;
      }
      this.handleFormChanges();
    },
    increaseQuantity(name, target) {
      this.selectedMaterials[name][target].quantity++;
      this.handleFormChanges();
    },
    handleFormChanges() {
      debounce(() => {
        this.$validator.validateAll().then((passed) => {
          if (
            passed
            && this.minScriptCountReached
            && (this.choices.playsWithMusic.length > 0 === this.requiresMusicFee || !this.requiresMusicFee)
          ) {
            this.step.selectedMaterials = this.selectedMaterials;

            return this.$emit('formValid');
          }

          this.$emit('formInvalid');
        }).catch(() => this.$emit('formInvalid'));
      }, 200)();
    },
  },
  computed: {
    requiresMusicFee() {
      const results = this.choices.playsWithMusic.find(({ IsMusicFeeMandatory }) => IsMusicFeeMandatory);

      return Boolean(results);
    },
    minScriptCountReached() {
      // If there are no scripts, allow the form to go through still
      if (this.choices.scripts.length == 0) return true;

      const scriptCount = Object.values(this.step.selectedMaterials.scripts).map(({ quantity }) => quantity).reduce((results, qty) => results + qty, 0);

      return Boolean(this.productInfo.MinRequiredScriptCount) === false || this.productInfo.MinRequiredScriptCount - scriptCount < 1;
    },
    remainingScriptCount() {
      const scriptCount = Object.values(this.step.selectedMaterials.scripts).map(({ quantity }) => quantity).reduce((results, qty) => results + qty, 0);

      const remaining = this.productInfo.MinRequiredScriptCount - scriptCount

      return `Select at least ${remaining} more script${remaining === 1 ? '' : 's'} to continue`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Estimator/LicenceEstimatorMaterials.vue